<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-toolbar flat dense color="primary" dark>
            <v-toolbar-title>
              {{ $tc('models.subscription', 2) }}
            </v-toolbar-title>
            <v-spacer />
            <v-btn
              v-if="can('create', 'user')"
              flat
              @click="setNewSubscription = true"
            >
              {{ $t('action.buttons.new') }}
            </v-btn>
            <dialog-new-subscription
              :id="id"
              v-model="setNewSubscription"
              :email="email"
              :type-member="'user'"
              @refresh="init"
            />
            <v-btn v-if="id" icon dark :loading="loading" @click="init">
              <v-icon>refresh</v-icon>
            </v-btn>
          </v-toolbar>
          <v-toolbar card flat dense color="white">
            <v-text-field
              v-model="match"
              flat
              hide-details
              :placeholder="$t('action.buttons.search')"
              prepend-icon="search"
              solo
            />
          </v-toolbar>
          <v-divider />
          <v-card-text class="pa-0">
            <v-data-table
              :headers="headers"
              :items="userSubscriptions"
              disable-initial-sort
              :search="match"
              :loading="loading"
              :rows-per-page-items="[8]"
            >
              <template slot="items" slot-scope="props">
                <td class="text-xs-center px-0">
                  <!-- <v-icon color="error" v-if="!props.item.paymentId" @click="openConfirmModal('delete', props.item._id)"
                    >delete</v-icon
                  > -->
                  <v-tooltip top>
                    <template #activator="{ on }">
                      <v-icon
                        color="warning"
                        class="mr-1"
                        @click="openConfirmModal('cancel', props.item._id)"
                        v-on="on"
                      >
                        close
                      </v-icon>
                    </template>
                    <span>{{ $t('action.buttons.cancel') }}</span>
                  </v-tooltip>
                  <v-tooltip v-if="props.item.paymentId" top>
                    <template #activator="{ on }">
                      <v-icon
                        color="error"
                        class="mr-1"
                        @click="openConfirmModal('refund', props.item._id)"
                        v-on="on"
                      >
                        money
                      </v-icon>
                    </template>
                    <span>{{ $t('action.buttons.refund') }}</span>
                  </v-tooltip>
                </td>
                <td>{{ props.item.typeSubscription || '--' }}</td>
                <td>{{ props.item.typePayment }}</td>
                <td class="text-xs-center">
                  {{ props.item.startAt || '--' }}
                </td>
                <td class="text-xs-center">
                  {{ props.item.expireAt || '--' }}
                </td>
                <td class="text-xs-center">
                  <button-state :state="props.item.status" />
                </td>
                <td>
                  {{ getStorage(props.item) }}
                </td>
                <td class="text-xs-center">
                  <button-state :state="!!props.item.isTrial" />
                </td>
                <td class="text-xs-center">
                  <v-btn
                    v-if="props.item.linkedAccounts"
                    flat
                    icon
                    color="primary"
                    @click="onLinkedAccounts(props.item._id)"
                  >
                    <v-icon>visibility</v-icon>
                  </v-btn>

                  <span v-else>--</span>
                </td>
                <td class="text-xs-center">
                  <v-btn
                    v-if="props.item.invoiceUrl"
                    flat
                    icon
                    color="primary"
                    @click="onInvoice(props.item.invoiceUrl)"
                  >
                    <v-icon>visibility</v-icon>
                  </v-btn>

                  <span v-else>--</span>
                </td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <dialog-linked-accounts
      v-model="dialogLinkedAccounts"
      :subscription-id="subscriptionId"
    />
    <dialog-confirm
      v-model="dialogConfirm"
      :text="confirmText"
      @submit="actionSubmit"
    />
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import DialogConfirm from '@/components/widgets/dialog/DialogConfirm'
import DialogLinkedAccounts from '@/components/widgets/dialog/DialogLinkedAccounts'
import DialogNewSubscription from '@/components/widgets/dialog/DialogNewSubscription'
export default {
  name: 'TabSubscriptions',
  components: { DialogNewSubscription, DialogLinkedAccounts, DialogConfirm },
  props: {
    id: { type: String, required: false, default: '' },
    email: String,
  },
  data() {
    return {
      match: '',
      loading: false,
      subscriptionId: '',
      dialogLinkedAccounts: false,
      setNewSubscription: false,
      dialogConfirm: false,
      actionType: '',
      confirmText: '',
    }
  },
  computed: {
    ...mapGetters({
      userSubscriptions: 'users/userSubscriptions',
    }),

    headers() {
      let headers = [
        {
          text: this.$t('fields.global.actions'),
          align: 'center',
          sortable: false,
        },
        {
          text: this.$tc('models.typeSubscription'),
          value: 'typeSubscription',
        },
        {
          text: this.$tc('fields.typeSubscriptions.typePayment'),
          value: 'typePayment',
        },
        {
          text: this.$t('fields.subscriptions.startAt'),
          value: 'startAt',
          align: 'center',
        },
        {
          text: this.$t('fields.subscriptions.expireAt'),
          value: 'expireAt',
          align: 'center',
        },

        {
          text: this.$t('titles.matches.status'),
          value: 'status',
          align: 'center',
        },
        {
          text: this.$t('titles.users.usedStorage'),
          value: 'usedStorage',
        },
        {
          text: this.$t('fields.subscriptions.isTrial'),
          value: 'isTrial',
          align: 'center',
        },
        {
          text: this.$t('fields.typeSubscriptions.linkedAccounts'),
          align: 'center',
        },
        {
          text: this.$t('titles.global.invoice'),
          align: 'center',
        },
      ]

      return headers
    },
  },
  methods: {
    ...mapActions({
      fetchUserSubscriptions: 'users/fetchUserSubscriptions',
      cancelSubscription: 'subscriptions/cancelSubscription',
      refundSubscription: 'subscriptions/refundSubscription',
      deleteSubscription: 'subscriptions/deleteSubscription',
    }),

    init() {
      if (this.id) {
        this.loading = true
        this.fetchUserSubscriptions(this.id).finally(() => {
          this.loading = false
        })
      }
      this.setNewSubscription = false
    },
    getStorage(item) {
      let { usedStorage, typeSubscriptionStorage } = item
      return `${usedStorage} / ${typeSubscriptionStorage} MB`
    },
    onLinkedAccounts(subscriptionId) {
      this.subscriptionId = subscriptionId
      this.dialogLinkedAccounts = true
    },
    onInvoice(invoiceUrl) {
      var win = window.open(invoiceUrl, '_blank')
      win.focus()
    },
    openConfirmModal(type, subId) {
      this.actionType = type
      this.subscriptionId = subId
      if (type === 'refund') {
        this.confirmText = this.$t('titles.global.confirmRefundSubscription')
      } else if (type === 'delete') {
        this.confirmText = this.$t('titles.global.confirmDelete')
      } else if (type === 'cancel') {
        this.confirmText = this.$t('titles.global.confirmCancelSubscription')
      }
      this.dialogConfirm = true
    },
    actionSubmit() {
      if (this.actionType === 'refund') {
        this.refundSubscription(this.subscriptionId)
      } else if (this.actionType === 'delete') {
        this.deleteSubscription(this.subscriptionId)
      } else if (this.actionType === 'cancel') {
        this.cancelSubscription(this.subscriptionId)
      }
      this.init()
    },
  },
}
</script>
